import { NIVA_NAV_URL } from "@/common/niva.config";
import Image from "next/image";

const NivaProduct = () => {
  return (
    <section className="py-6 md:py-8" aria-labelledby="niva-product-heading">
      <div className="container max-w-7xl">
        <div className="flex flex-col items-start justify-between gap-4 rounded-2xl border border-line bg-surface px-5 py-5 shadow-[0_12px_32px_-22px_rgba(15,28,26,0.18)] sm:flex-row sm:items-center sm:px-6">
          <div className="flex min-w-0 items-start gap-3 sm:items-center">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-line bg-muted">
              <Image
                src="/icons/niva_logo.svg"
                alt=""
                width={24}
                height={24}
                className="niva-mark h-6 w-6 object-contain"
              />
            </span>
            <div className="min-w-0">
              <h2
                id="niva-product-heading"
                className="text-base font-semibold text-ink sm:text-lg"
              >
                NIVA
                <span className="font-normal text-ink-muted">
                  {" "}
                  · Agentic chatbots for industry teams
                </span>
              </h2>
              <p className="mt-0.5 text-sm text-ink-muted">
                Personas, workflows, and white-label deploy without a long build
                cycle.
              </p>
            </div>
          </div>
          <a
            href={NIVA_NAV_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="landing-btn-primary shrink-0 !px-5 !py-2.5 text-sm"
          >
            Explore NIVA
          </a>
        </div>
      </div>
    </section>
  );
};

export default NivaProduct;
